import { render, staticRenderFns } from "./ViewPrivacyNotice.vue?vue&type=template&id=1fce04e3&scoped=true"
import script from "./ViewPrivacyNotice.vue?vue&type=script&lang=js"
export * from "./ViewPrivacyNotice.vue?vue&type=script&lang=js"
import style0 from "./ViewPrivacyNotice.vue?vue&type=style&index=0&id=1fce04e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fce04e3",
  null
  
)

export default component.exports